import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetPassengers, IGetBusSchedules, IGetStations, IMessageReq, IGetBusStatus, IBusStatusReq } from '../models/shuttleHelper.model';

const uri = '/mgmt/shuttle-helper';

export const getBusSchedules = (campusCode: string, date: string): AxiosPromise<IGetBusSchedules> => {
  return axios.get(`${uri}/${campusCode}/${date}`);
};

export const getPassengers = (campusCode: string, runningCode: number, rideGbn: string, date: string): AxiosPromise<IGetPassengers> => {
  return axios.get(`${uri}/${campusCode}/student-info/${runningCode}/${rideGbn}/${date}`);
};

export const getBusStatus = (campusCode: string, runningCode: number, rideGbn: string, date: string): AxiosPromise<IGetBusStatus> => {
  return axios.get(`${uri}/${campusCode}/${runningCode}/${rideGbn}/${date}`);
};

export const updateBusStatus = (campusCode: string, runningCode: number, data: IBusStatusReq): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/running/${runningCode}`, data);
};

export const sendMessages = (campusCode: string, data: IMessageReq[]): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}/send-message`, data);
};

export const getStations = (campusCode: string, runningCode: number): AxiosPromise<IGetStations> => {
  return axios.get(`${uri}/${campusCode}/search/${runningCode}`);
};
